<template>
  <el-cascader
    ref="cascader"
    class="dict-select"
    :class="{select__block: !inline}"
    :value="value"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :props="{ expandTrigger: 'hover' }"
    :debounce="300"
    :options="dataList"
    filterable
    @input.native="handleFilter"
    @change="handleChange"
    @input="$emit('input', $event)"
  >
  </el-cascader>
</template>

<script>
import { fetchList as fetchFieldTypeList } from '@/api/template/fieldType'
export default {
  name: 'FieldTypeSelect',
  props: {
    value: {},
    placeholder: {
      default: '请选择'
    },
    inline: {
      default: true
    },
    disabled: {},
    clearable: {
      default: false
    }
  },
  data () {
    return {
      dataList: [],
      remoteSearchData: {
        isWorking: false,
        timeout: null
      }
    }
  },
  methods: {
    // 变更
    handleChange (value) {
      // 选中一级
      if (value.length === 1) {
        this.$emit('change', this.dataList.find(item => item.value === value[0]))
        return
      }
      // 选中二级
      if (value.length === 2) {
        const children = this.dataList.find(item => item.value === value[0]).children
        this.$emit('change', children.find(item => item.variable === value[1]))
      }
    },
    // 加载数据
    fetchData (keyword) {
      // 没有值也没有搜索关键字
      if ((this.value == null || this.value.length === 0) && (keyword == null || keyword.trim() === '')) {
        this.dataList = []
        return
      }
      if (this.remoteSearchData.isWorking) {
        return
      }
      this.remoteSearchData.isWorking = true
      // 查询数据
      fetchFieldTypeList({
        page: 1,
        capacity: 10000,
        model: {
          id: keyword == null || keyword === '' ? this.value[0] : null,
          keyword
        }
      })
        .then(data => {
          const originDataList = this.dataList
          this.dataList = data.records.map(item => {
            // 非对象类型
            if (item.category !== 'OBJECT') {
              return {
                label: item.label,
                value: item.id,
                variable: item.variable,
                type: item.category
              }
            }
            // 对象类型，选中对象字段配置
            return {
              label: item.label,
              value: item.id,
              variable: item.variable,
              type: item.category,
              children: JSON.parse(item.fieldConfig).map(itemField => {
                return {
                  label: itemField.label,
                  value: itemField.variable,
                  variable: itemField.variable,
                  type: itemField.type,
                  typeId: item.id
                }
              })
            }
          })
          // 判断是否包含当前选中的值
          if (this.value != null && this.value.length > 0) {
            const targetOption = this.dataList.find(item => item.value === this.value[0])
            if (targetOption == null) {
              const selectedValue = originDataList.find(item => item.value === this.value[0])
              if (selectedValue != null) {
                this.dataList.unshift(selectedValue)
              }
            }
          }
          // 存在搜索关键字，重新匹配一次
          if (keyword != null && keyword.length > 0) {
            this.$nextTick(() => {
              this.$refs.cascader.getSuggestions()
            })
          }
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.remoteSearchData.isWorking = false
        })
    },
    // 搜索
    handleFilter (e) {
      if (this.remoteSearchData.timeout != null) {
        clearTimeout(this.remoteSearchData.timeout)
      }
      this.remoteSearchData.timeout = setTimeout(() => {
        let keyword = e.target.value
        keyword = keyword.replace(/['"{},:]/g, '')
        this.fetchData(keyword)
      }, 1000)
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style lang="scss" scoped>
.select__block {
  display: block;
}
</style>
